import React, { useEffect } from "react";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { TaxonomyType } from "data/types";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import SectionGridCategoryBox from "components/SectionGridCategoryBox/SectionGridCategoryBox";
import SectionHero3 from "components/SectionHero/SectionHero3";
import CardCategory6 from "components/CardCategory6/CardCategory6";
import StatsSection from "components/SectionStat/StatsSection";
import BusinessFeatureSection from "components/SectionBusinessFeature/BusinessFeatureSection";
import { booking, business, loyalty } from "data/business";

const DEMO_CATS_2: TaxonomyType[] = [
  {
    id: "1",
    href: "/listing-stay",
    name: "Restaurants",
    taxonomy: "category",
    count: 2657,
    unit: "restaurants",
    thumbnail:
      "https://images.pexels.com/photos/260922/pexels-photo-260922.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: "222",
    href: "/listing-stay",
    name: "Spa and Beauty",
    taxonomy: "category",
    count: 547,
    unit: "salons",
    thumbnail:
      "https://images.pexels.com/photos/853427/pexels-photo-853427.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: "3",
    href: "/listing-stay",
    name: "Outdoor Activities",
    taxonomy: "category",
    count: 895,
    unit: "activities",
    thumbnail:
      "https://images.pexels.com/photos/7031413/pexels-photo-7031413.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  },
  {
    id: "4",
    href: "/listing-stay",
    name: "Entertainments",
    taxonomy: "category",
    count: 1250,
    unit: "stores",
    thumbnail:
      "https://images.pexels.com/photos/54123/pexels-photo-54123.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: "5",
    href: "/listing-stay",
    name: "Hotels and Travels",
    taxonomy: "category",
    count: 3250,
    unit: "services",
    thumbnail:
      "https://images.pexels.com/photos/386009/pexels-photo-386009.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
];

function PageHome3() {
  // CUSTOM THEME STYLE
  useEffect(() => {
    const $body = document.querySelector("body");
    if (!$body) return;
    $body.classList.add("theme-purple-blueGrey");
    return () => {
      $body.classList.remove("theme-purple-blueGrey");
    };
  }, []);

  return (
    <div className="nc-PageHome3 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(1600px_800px_at_0%_0%,rgba(190,18,60,0.55)_0%,transparent_65%),radial-gradient(1200px_600px_at_100%_100%,rgba(190,18,60,0.55)_0%,transparent_65%)]" />

      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      {/* SECTION HERO */}
      <SectionHero3
        className=""
        onExploreClick={() => {
          const target = document.getElementById("TopBusiness");
          if (target) {
            target.scrollIntoView({ behavior: "smooth" });
          }
        }}
      />

      <div className="container relative space-y-24 mb-24">
        {/* SECTION */}
        {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionGridFeaturePlaces />
        </div> */}

        {/* SECTION */}
        <div className="relative pb-32  space-y-24" id="TopBusiness">
          <BackgroundSection />

          {/* <SectionGridAuthorBox boxCard="box2" /> */}

          <SectionGridAuthorBox
            headingText="Top Businesses of the Month"
            authors={business.filter((_, i) => i < 10)}
            boxCard="box2"
          />

          {/* Booking section */}
          <SectionGridAuthorBox
            headingText="Top Booking Businesses"
            authors={booking}
            boxCard="box2"
          />

          {/* Loyalty section */}
          <SectionGridAuthorBox
            headingText="Top Loyalty Rewards"
            authors={loyalty}
            boxCard="box2"
          />
        </div>

        {/* SECTION */}
        <div className="relative py-16">
          <SectionHowItWork />
        </div>
        {/* SECTION 1 */}
        {/* <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 sm:col-span-6 lg:col-span-4 flex">
            <CardCategory6 taxonomy={DEMO_CATS_2[0]} />
          </div>
          <div className="col-span-12 sm:col-span-6 lg:col-span-4 grid grid-rows-2 gap-6">
            <CardCategory6 taxonomy={DEMO_CATS_2[3]} />
            <CardCategory6 taxonomy={DEMO_CATS_2[1]} />
          </div>
          <div className="col-span-12 sm:col-span-6 lg:col-span-4 flex">
            <CardCategory6 taxonomy={DEMO_CATS_2[4]} />
          </div>
        </div> */}

        {/* SECTION */}
        {/* <SectionSubscribe2 /> */}

        {/* SECTION */}
        <StatsSection />
        <BusinessFeatureSection />
        <div className="relative py-16">
          <SectionGridCategoryBox />
        </div>
      </div>
    </div>
  );
}

export default PageHome3;
